export function trimStringValueNormalize(value: any) {
    if (typeof value === "string") {
        return value.trim();
    }

    return value;
}
